import Vue from 'vue';
import Vuex from 'vuex';
import adblock from './modules/adblock';
import atdsTracking from './modules/atdsTracking';
import config from './modules/config';
import hero from './modules/hero';
import platform from './modules/platform';

Vue.use(Vuex);

export default new Vuex.Store({
  getters: {
    adblockDetected(state) {
      return state.adblock.detected;
    },
    atdsTrackingBlocked(state, getters) {
      return getters['atdsTracking/blocked'];
    },
  },
  modules: {
    adblock,
    atdsTracking,
    config,
    hero,
    platform,
  },
});
